import { render, staticRenderFns } from "./NewSingleProductPanelItem.vue?vue&type=template&id=a1f62a38&scoped=true&"
import script from "./NewSingleProductPanelItem.vue?vue&type=script&lang=js&"
export * from "./NewSingleProductPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./NewSingleProductPanelItem.vue?vue&type=style&index=0&id=a1f62a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f62a38",
  null
  
)

export default component.exports